// extracted by mini-css-extract-plugin
module.exports = {"container":"MoreCategorySection_container__NTyRU","title":"MoreCategorySection_title__EAHr8"};